<template>
  <div class="login">
    <div class="logo">
      <img src="../assets/images/logo.png">
    </div>
    <div class="loginMain">
      <div class="loginTitle">账号登录</div>
      <div class="formMain">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <el-form-item
            label=""
            prop="phoneNumber"
            abel-width="0px"
          >
            <div class="labelText">手机号码</div>
            <el-input v-model="ruleForm.phoneNumber"></el-input>
          </el-form-item>
          <el-form-item
            label=""
            abel-width="0px"
            prop="vcode"
          >
            <div class="labelText">验证码</div>
            <el-input
              v-model="ruleForm.vcode"
              style="width:270px;margin-right:30px"
            ></el-input>
            <el-button
              @click="getCode"
              type="primary"
              plain
              style="width:100px;padding-left:0px;padding-right:0px"
            >获取验证码</el-button>
          </el-form-item>
          <el-form-item label-width="0px">
            <div class="btnBoxFull">
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
              >登录</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getVerificationCode, login } from 'api/request'
export default {
  data() {
    return {
      ruleForm: {
        phoneNumber: '',
        vcode: ''
      },
      rules: {
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        vcode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let parmas = {
            phoneNumber: this.ruleForm.phoneNumber,
            vcode: this.ruleForm.vcode
          }
          login(parmas).then(data => {
            if (data) {
              window.sessionStorage.setItem('token', data.token)
              window.sessionStorage.setItem(
                'loginuser',
                JSON.stringify({ mobile: data.mobile, name: data.name })
              )
              this.$router.push({
                path: '/'
              })
              this.$message({
                message: '登录成功',
                type: 'success'
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getCode() {
      if (this.ruleForm.phoneNumber) {
        // let parmas = {
        //   phoneNumber: this.ruleForm.phoneNumber
        // }
        console.log(this.ruleForm.phoneNumber)
        let data = await getVerificationCode(this.ruleForm.phoneNumber)
        if (data) {
          this.$message({
            message: '已发送验证码，请查收',
            type: 'success'
          })
        }
      } else {
        this.$message({
          message: '请输入手机',
          type: 'error'
        })
      }
    }
  }
}
</script>
<style  lang='scss'>
.login {
  height: 100%;
  width: 100%;
  .logo {
    margin: 40px 0 50px 120px;
    height: 180px;
    width: 180px;
    img {
      height: 100%;
      cursor: pointer;
    }
  }
  .loginMain {
    width: 400px;
    margin: 80px auto 0;
    .loginTitle {
      height: 100px;
      line-height: 100px;
      font-size: 20px;
      text-align: center;
    }
    .btnBox {
      display: flex;
      justify-content: center;
    }
  }
  .labelText {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 10px;
  }
  .btnBoxFull {
    width: 100%;
    .el-button {
      width: 100%;
    }
  }
}
</style>
